// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"6d05fdb1","54":"7a5f9d8c","169":"27833857","242":"1c6525f9","385":"cc7a60d5","390":"b443c1c9","466":"7b3d7299","519":"54908e66","528":"b3599642","575":"5b0bd71f","684":"df012c14"}[chunkId] + ".chunk.js";
};